// cart-pocket-sync.js — keeps pocket add-ons in sync in cart drawer/cart page
(function () {
  const ADDON_FLAG = "front_pocket";        // item.properties._addon
  const PARENT_UID_PROP = "_parent_uid";    // addon points to parent uid
  const PARENT_HAS_UID_PROP = "_pocket_uid"; // parent stores its uid

  let internalBypass = false;

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart.js");
    return res.json();
  }

  async function changeLineItemByKey(lineItemKey, quantity) {
    internalBypass = true;
    try {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: lineItemKey, quantity })
      });
    } finally {
      internalBypass = false;
    }
  }

  async function reconcilePocketAddons() {
    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      console.error("[Pocket Sync] Could not load cart:", e);
      return;
    }

    const items = cart.items || [];

    // parent_uid -> desired quantity
    const parentQtyByUid = new Map();
    for (const item of items) {
      const isAddon = item?.properties?._addon === ADDON_FLAG;
      if (isAddon) continue;

      const uid = item?.properties?.[PARENT_HAS_UID_PROP];
      if (uid) parentQtyByUid.set(uid, item.quantity);
    }

    const addonItems = items.filter((it) => it?.properties?._addon === ADDON_FLAG);

    for (const addon of addonItems) {
      const parentUid = addon.properties?.[PARENT_UID_PROP];

      // remove orphan
      if (!parentUid || !parentQtyByUid.has(parentUid)) {
        await changeLineItemByKey(addon.key, 0);
        continue;
      }

      // sync qty
      const desiredQty = parentQtyByUid.get(parentUid);
      if (addon.quantity !== desiredQty) {
        await changeLineItemByKey(addon.key, desiredQty);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(reconcilePocketAddons, 150);
  });

  // Re-run after cart mutations (without reacting to our own /cart/change.js calls)
  const _fetch = window.fetch;
  let isReconciling = false;
  let reconcileQueued = false;

  function scheduleReconcile() {
    if (isReconciling) {
      reconcileQueued = true;
      return;
    }
    setTimeout(async () => {
      isReconciling = true;
      try {
        await reconcilePocketAddons();
      } finally {
        isReconciling = false;
        if (reconcileQueued) {
          reconcileQueued = false;
          scheduleReconcile();
        }
      }
    }, 150);
  }

  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    // if this script is the one doing cart/change, don’t reschedule off itself
    if (internalBypass) return res;

    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

      // never react to cart.js GETs
      if (url.endsWith("/cart.js")) return res;

      const isCartMutation =
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear");

      if (isCartMutation) scheduleReconcile();
    } catch (_) {}

    return res;
  };
})();
